import React, { useContext, useEffect } from 'react';
import { Row, Col } from 'antd';

import PremiumBanner from './BannerText';
import PricingCard from './PricingCard';

export default function PremiumSection() {
  return (
    <div>
      <Row
        style={{
          backgroundColor: '#30393B',
        }}
      >
        <Col xs={24}>
          <PremiumBanner />
          <PricingCard />
        </Col>
      </Row>
    </div>
  );
}
